var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',[_c('h6',{staticClass:"text-xl font-light mb-2",domProps:{"textContent":_vm._s('Table of content')}}),_vm._l((_vm.contents),function({ level, id, text }){return _c('a',{key:text,staticClass:"block truncate",class:{
      'ml-4': level === 3,
      'ml-6': level === 4,
      'ml-8': level === 5,
      'ml-10': level === 6
    },attrs:{"href":`#${id}`},domProps:{"textContent":_vm._s(text)}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }